import axios from "@/plugins/axios";

export const state = () => ({
  sales_return_visible: false,
  sales_return_products: {},
  sales_return_details: {},
});

export const mutations = {
  // set products in state
  SET_SALE_RETURN_PRODUCTS(state, payload) {
    // state.sales_return_products = payload;
    state.sales_return_products = payload.map((item) => {
      return {
        fixedquantity: item.quantity,
        product: item.product,
        batch: item.batch,
        unit: item.unit,

        quantity: item.quantity,
        amount: item.amount,
        bargain_discount: item.bargain_discount,
        return_charge: item.return_charge ? item.return_charge : 0,

        name: item.product.name,
        productInformation: item.product,
        discount: item.sale.discount_amount,
        maxQuantity: item.quantity,
      };
    });
  },
  SET_SALE_RETURN_DATA(state, payload) {
    state.sales_return_products = payload;
  },
  // set SalesDetails Data in state
  SET_SALE_RETURN_DATA(state, payload) {
    state.sales_return_details = payload;
  },
  // set SalesRetuen visble in state
  SET_SALE_RETURN_VISIBLE(state, payload) {
    state.sales_return_visible = payload;
  },
  // set SalesRetuen quantity changes in state
  CHANGE_QUANTITY(state, payload) {
    var products = state.sales_return_products;
    products[payload.index].quantity = payload.quantity;
    state.sales_return_products = products;
  },
  // Remove index in State
  REMOVE_PRODUCT(state, index) {
    var addedProducts = state.sales_return_products;
    addedProducts.splice(index, 1);
    state.sales_return_products = addedProducts;
  },
};

export const actions = {
  //remove Product In salesReturn
  removeProduct({ commit }, index) {
    commit("REMOVE_PRODUCT", index);
  },
  // set the visble function sales return
  async setVisibleSalesReturn({ commit }, value) {
    commit("SET_SALE_RETURN_VISIBLE", value);
  },
  // set the  sales return Details
  async setSalesReturnDatas({ commit }, index) {
    commit("SET_SALE_RETURN_DATA", index);
  },

  // Get Sales Return Products And Store In state
  async fetchProductsSalesReturn({ commit }, payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`pos/sales/${payload.salesid}/products?query=`)
        .then((res) => {
          commit("SET_SALE_RETURN_PRODUCTS", res.data.data);

          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // Post Sales Return Products
  async submitSalesReturn({}, payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(`pos/sale-return/`, payload)
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export const getters = {
  //Get Total Amount Sales Return Product List
  GetTotalAmount: function(state) {
    if (state.sales_return_products.length == 0) return 0;
    var total = state.sales_return_products.reduce(function(a, b) {
      if (b.bargain_discount) {
        return a + b.quantity * (b.amount - b.bargain_discount);
      }
    }, 0);
    return total;
  },

  //Get Total Discount Sales Return Product List

  GetDiscountAmount: function(state) {
    if (state.sales_return_products.length == 0) return 0;

    var total = state.sales_return_products.reduce(function(a, b) {
      if (b.bargain_discount) {
        return (a + b.quantity) * parseInt(b.bargain_discount);
      }
    }, 0);

    return total;
  },
  GetReturnChargeAmount: function(state) {
    if (state.sales_return_products.length == 0) return 0;

    var total = state.sales_return_products.reduce(function(a, b) {
      if (b.return_charge) {
        return parseFloat(a) + parseFloat(b.return_charge);
      }
      return 0;
    }, 0);

    return total;
  },
  //Get Total Payable amount
  GetTotalPayableAmount: function(state, getters) {
    return (
      getters.GetTotalAmount -
      (getters.GetDiscountAmount + getters.GetReturnChargeAmount)
    );
  },
  GetProductsCount: function(state) {
    return state.sales_return_products.length;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
